<template>
    <v-modal title="Abandon invoice" size="small" @close="$emit('close')">
        <div slot="contents">
            <div class="modal-content">
                <div class="grid-item grid-item-full">
                    <p>Are you sure you want to abandon this Invoice?</p>
                </div>
            </div>
        </div>

        <template slot="actions">
            <r-button
                type="danger"
                @click="voidInvoice">Abandon</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        components: {
            vModal,
        },
        methods: {
            voidInvoice() {
                this.$emit('abandon-invoice');
                this.$emit('close');
            },
        },
    };
</script>
